// extracted by mini-css-extract-plugin
module.exports = {"editor_container":"NewsDetails_editor_container__tpcbx","center":"NewsDetails_center__ACZ9s","top_toolbar":"NewsDetails_top_toolbar__3YbiY"};